// @flow
import React, { useState, useEffect } from 'react';

const cachedScripts = [];

export function useScriptLoader(scriptUrl: string) {
  const [scriptLoaded, setScriptLoaded] = useState(cachedScripts.includes(scriptUrl));
  const [scriptLoadingFailed, setScriptLoadingFailed] = useState(false);

  useEffect(
    () => {
      if (scriptLoaded) {
        return;
      }

      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;

      new Promise((resolve, reject) => {
        script.addEventListener('load', () => resolve(scriptUrl));
        script.addEventListener('error', e => reject(e));
      })
        .then(() => {
          cachedScripts.push(scriptUrl);
          setScriptLoaded(true);
        })
        .catch(() => {
          script.remove();

          setScriptLoadingFailed(true);
        });

      // $FlowFixMe
      document.body.appendChild(script);
    },
    [scriptUrl],
  );

  return { scriptLoaded, scriptLoadingFailed };
}
